export default {
  methods: {
    formatText(text) {
      return text
        ? text.trim().charAt(0).toUpperCase() +
            text.trim().substr(1).toLowerCase()
        : "";
    },
    formatPrice(amount) {
      return amount ? `${Number(amount).toLocaleString()}` : "0.00";
    },
  },
};
